import React, { FC } from 'react';
import { Button, Card, CardBody, CardText, CardTitle, Col, Row } from 'reactstrap';
import { useTranslation } from '../translations';
import { MaterialIcon } from '.';

interface LoadingErrorProps {
  readonly retryCallback?: () => void;
  readonly errorText?: string;
}

export const LoadingError: FC<LoadingErrorProps> = ({
  errorText,
  retryCallback,
}): React.JSX.Element => {
  const { ts } = useTranslation();

  if (!errorText) {
    errorText = ts('loading_error.error_text');
  }

  return (
    <Row className="justify-content-center" id="loadingError">
      <Col lg={6} xs={12}>
        <Card className="warning">
          <CardBody className="text-center">
            <MaterialIcon large name="sync_problem" type="warning" />
            <CardTitle>{ts('loading_error.something_went_wrong')}</CardTitle>
            <CardText tag="div">
              <p>{ts('common.error_encountered')}</p>
              <p>{ts('loading_error.try_reloading_the_page_or')}</p>
              <p>
                <small>{errorText}</small>
              </p>
              {retryCallback && (
                <Button block color="primary" onClick={retryCallback} outline>
                  {ts('loading_error.retry')}
                </Button>
              )}
            </CardText>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};
